import {
  APP_FIELD_FILTER_REQUEST,
  APP_FIELD_FILTER_REQUEST_SUCCESS,
  APP_FIELD_FILTER_REQUEST_FAILURE,
  APP_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const appFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case APP_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case APP_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case APP_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case APP_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default appFilterFieldsReducer;
